import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import searchIco from '../../assets/images/searchIco.png'
import { CreateGerencia, Getgerencia, UpdateGerencia } from '../../data'
import { addGerenTotal } from '../../store/gerencias/TotalGerenSlice'

export const GerenciasAdmin = () => {
    const cargos = ['Gerente', 'Vendedor', 'Administracion']
    const dispatch = useDispatch()
    const totalGeren = useSelector((state) => state.totalGeren)
    const [searchTerm, setSearchTerm] = useState('')
    const [saving, setSaving] = useState(false)
    const [editingDocId, setEditingDocId] = useState('')
    const [formData, setFormData] = useState({
        Id: '',
        Administracion: '',
        Gerencia: '',
        Vendedor: '',
        Cargo: 'Gerente',
        AreaDeVentas: '',
    })

    const resetForm = () => {
        setFormData({
            Id: '',
            Administracion: '',
            Gerencia: '',
            Vendedor: '',
            Cargo: 'Gerente',
            AreaDeVentas: '',
        })
        setEditingDocId('')
    }

    const normalizeText = (value) => {
        if (!value) return ''
        return value
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
    }

    const filteredGerencias = useMemo(() => {
        const search = normalizeText(searchTerm.trim())
        const source = Array.isArray(totalGeren) ? totalGeren : []
        const sorted = [...source].sort((a, b) => Number(a?.Id || 0) - Number(b?.Id || 0))

        if (!search) return sorted

        return sorted.filter((item) => {
            const fields = [
                item?.Id,
                item?.AreaDeVentas,
                item?.Gerencia,
                item?.Vendedor,
                item?.Administracion,
                item?.Direccion,
                item?.Cargo,
                item?.DocID,
            ]
            return fields.some((field) => normalizeText(field).includes(search))
        })
    }, [totalGeren, searchTerm])

    const handleInputChange = ({ target }) => {
        setFormData((prev) => ({
            ...prev,
            [target.name]: target.value,
        }))
    }

    const handleEditGerencia = (item) => {
        setFormData({
            Id: item?.Id?.toString() || '',
            Administracion: item?.Administracion?.toString() || '',
            Gerencia: item?.Gerencia?.toString() || '',
            Vendedor: item?.Vendedor?.toString() || '',
            Cargo: cargos.includes(item?.Cargo) ? item.Cargo : 'Gerente',
            AreaDeVentas: item?.AreaDeVentas?.toString() || '',
        })
        setEditingDocId(item?.DocID?.toString() || '')
    }

    const handleCancelEdit = () => {
        resetForm()
    }

    const handleSubmitGerencia = async (event) => {
        event.preventDefault()

        const payload = {
            ...formData,
            Id: formData.Id.trim(),
            Administracion: formData.Administracion.trim(),
            Gerencia: formData.Gerencia.trim(),
            Vendedor: formData.Vendedor.trim(),
            Cargo: formData.Cargo.trim() || 'Gerente',
            AreaDeVentas: formData.AreaDeVentas.trim() || `${formData.Id.trim()} - Gerencia`,
        }

        setSaving(true)
        try {
            const result = editingDocId
                ? await UpdateGerencia({ ...payload, DocID: editingDocId })
                : await CreateGerencia(payload)
            if (!result?.ok) return

            const updatedGerencias = await Getgerencia()
            dispatch(addGerenTotal(updatedGerencias))
            resetForm()
        } finally {
            setSaving(false)
        }
    }

    return (
        <div className="p-2 mb-3">
            <div className="mt-2">
                <h4 className="separar my-4">
                    <b className="text-uppercase">Gerencias</b>
                </h4>

                <form className="gerenciasCreateForm" onSubmit={handleSubmitGerencia}>
                    {editingDocId && (
                        <div className="gerenciasEditInfo">
                            Modo edicion activo. DocID: {editingDocId}
                        </div>
                    )}
                    <div className="gerenciasCreateFields">
                        <input
                            className="form-control inputs"
                            name="Id"
                            placeholder="Id (ej: 1)"
                            value={formData.Id}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            className="form-control inputs"
                            name="Administracion"
                            placeholder='Administracion (ej: "04")'
                            value={formData.Administracion}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            className="form-control inputs"
                            name="Gerencia"
                            placeholder='Gerencia (ej: "B02")'
                            value={formData.Gerencia}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            className="form-control inputs"
                            name="Vendedor"
                            placeholder='Vendedor (ej: "B03")'
                            value={formData.Vendedor}
                            onChange={handleInputChange}
                            required
                        />
                        <select
                            className="form-control inputs"
                            name="Cargo"
                            value={formData.Cargo}
                            onChange={handleInputChange}
                            required
                        >
                            {cargos.map((cargo) => (
                                <option key={cargo} value={cargo}>
                                    {cargo}
                                </option>
                            ))}
                        </select>
                        <input
                            className="form-control inputs"
                            name="AreaDeVentas"
                            placeholder='AreaDeVentas (opcional, por defecto: "Id - Gerencia")'
                            value={formData.AreaDeVentas}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="gerenciasFixedValues">
                        Valores fijos: Activo=true, Direccion="01"
                    </div>

                    <div className="gerenciasActions">
                        <button
                            type="submit"
                            className="btn btn-outline btnBlue text-uppercase fw-bold gerenciasCreateButton"
                            disabled={saving}
                        >
                            {saving ? 'Guardando...' : editingDocId ? 'Actualizar Gerencia' : 'Crear Gerencia'}
                        </button>
                        {editingDocId && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary text-uppercase fw-bold"
                                onClick={handleCancelEdit}
                                disabled={saving}
                            >
                                Cancelar
                            </button>
                        )}
                    </div>
                </form>

                <div className="adminPanelToolbar mt-3">
                    <div className="adminSearch">
                        <img src={searchIco} alt="Buscar" className="adminSearchIcon" />
                        <input
                            type="text"
                            className="form-control inputs adminSearchInput"
                            placeholder="Buscar por Id, area, gerencia, vendedor o cargo"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="adminListMeta">
                        {filteredGerencias.length} de {Array.isArray(totalGeren) ? totalGeren.length : 0} gerencias activas
                    </div>
                </div>

                {filteredGerencias.length === 0 ? (
                    <div className="adminEmptyState">No hay gerencias para mostrar.</div>
                ) : (
                    <div className="gerenciasTableWrapper">
                        <table className="gerenciasTable">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>AreaDeVentas</th>
                                    <th>Administracion</th>
                                    <th>Gerencia</th>
                                    <th>Vendedor</th>
                                    <th>Direccion</th>
                                    <th>Cargo</th>
                                    <th>DocID</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredGerencias.map((item) => (
                                    <tr key={item.DocID || `${item.Id}-${item.Gerencia}`}>
                                        <td>{item.Id}</td>
                                        <td>{item.AreaDeVentas}</td>
                                        <td>{item.Administracion}</td>
                                        <td>{item.Gerencia}</td>
                                        <td>{item.Vendedor}</td>
                                        <td>{item.Direccion}</td>
                                        <td>{item.Cargo}</td>
                                        <td className="gerenciasDocId">{item.DocID}</td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                onClick={() => handleEditGerencia(item)}
                                            >
                                                Editar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    )
}
